import { isTeamInviteToken } from "./team-invite-pending";

const TICKET_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const DEVICE_CODE_PATTERN = /^[A-Z0-9]{8}$/;
const ACCOUNT_SECTION_PATTERN = /^#(overview|orders|devices|security|support)$/;

export function readAllowedReturnPath(
  raw: string | null,
  origin: string,
): string {
  if (!raw) {
    return "/account";
  }
  try {
    const candidate = new URL(raw, origin);
    if (candidate.origin !== origin) {
      return "/account";
    }

    const keys = [...candidate.searchParams.keys()];
    if (candidate.pathname === "/account") {
      if (keys.length || (candidate.hash && !ACCOUNT_SECTION_PATTERN.test(candidate.hash))) {
        return "/account";
      }
      return candidate.hash ? `/account${candidate.hash}` : "/account";
    }

    if (candidate.pathname === "/admin") {
      return keys.length || candidate.hash ? "/account" : "/admin";
    }

    if (candidate.pathname === "/account/teams") {
      return keys.length || candidate.hash ? "/account" : "/account/teams";
    }

    const teamInvite = /^\/join\/team\/([^/]+)$/.exec(candidate.pathname);
    if (teamInvite) {
      return keys.length || candidate.hash || !isTeamInviteToken(teamInvite[1]!)
        ? "/account"
        : `/join/team/${teamInvite[1]}`;
    }

    if (candidate.hash) {
      return "/account";
    }

    if (candidate.pathname === "/" && keys.length === 0) {
      return "/";
    }

    if (
      candidate.pathname === "/products/squad-tactical-planner" &&
      keys.length === 0
    ) {
      return "/products/squad-tactical-planner";
    }

    if (candidate.pathname === "/contact") {
      const ticket = candidate.searchParams.get("ticket");
      if (
        keys.some((key) => key !== "ticket") ||
        keys.length > 1 ||
        (ticket !== null && !TICKET_ID_PATTERN.test(ticket))
      ) {
        return "/account";
      }
      return ticket
        ? `/contact?ticket=${encodeURIComponent(ticket)}`
        : "/contact";
    }

    if (candidate.pathname === "/device") {
      const code = candidate.searchParams.get("user_code")?.toUpperCase();
      const launcher = candidate.searchParams.get("launcher");
      const returnMode = candidate.searchParams.get("return_mode");
      if (
        keys.some((key) => key !== "user_code" && key !== "launcher" && key !== "return_mode") ||
        keys.filter((key) => key === "user_code").length !== 1 ||
        keys.filter((key) => key === "launcher").length > 1 ||
        keys.filter((key) => key === "return_mode").length > 1 ||
        !code ||
        !DEVICE_CODE_PATTERN.test(code) ||
        (launcher !== null && launcher !== "bomana") ||
        (returnMode !== null && returnMode !== "redirect") ||
        (returnMode === "redirect" && launcher !== "bomana")
      ) {
        return "/account";
      }
      return `/device?user_code=${encodeURIComponent(code)}${launcher === "bomana" ? "&launcher=bomana" : ""}${returnMode === "redirect" ? "&return_mode=redirect" : ""}`;
    }

    return "/account";
  } catch {
    return "/account";
  }
}
